import React from 'react';
import {ServiceArr} from "../constants/index.js"

const Services = () => {
    return (
        <div className='w-full p-10 ser h-[50vh] '>
            <h1 className='font-bold text-6xl text-center text-purple-500 max-sm:text-3xl '>Chat smarter not Harder <br /> with BrainAI</h1>
            
        </div>
    );
}

export default Services;
